module.exports = require("@mui/icons-material/LastPage");